// Admin Routes
export const ADMIN_ROUTES = {
    DASHBOARD: '/admin/dashboard',
    REVIEW_CANDIDATES: '/admin/review-candidates',
    REVIEW_COMPANIES: '/admin/review-companies',
    CANDIDATE_SEARCH: '/admin/candidate-search',
    CANDIDATE_RECOMMENDATIONS: '/admin/candidate-recommendations',
    DAVID_INBOX: '/admin/david-inbox',
    MANAGE_JOBS: '/admin/manage-jobs',
    SYSTEM_SETTINGS: '/admin/system-settings',
    ANALYTICS: '/admin/analytics',
    USER_MANAGEMENT: '/admin/user-management',
} as const;
